import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

export interface OptionType {
  label: string;
  value: string | number;
}

interface CustomDropdownProps {
  options: OptionType[];
  defaultValue?: OptionType | string | number;
  value?: OptionType | string | number; 
  className?: string;
  placeholder?: string;
  modal?: boolean;
  onChange?: (value: OptionType) => void;
  name?: string;
}

const CustomSelect: React.FC<CustomDropdownProps> = ({
  options,
  value,
  defaultValue,
  className,
  placeholder,
  modal,
  onChange,
  name
}) => {

  // 🔹 Helper: normalize a given value into { value, label }
  const normalizeValue = (val: OptionType | string | number | undefined) => {
    if (val === undefined || val === null) return undefined;

    if (typeof val === 'object' && 'value' in val && 'label' in val) {
      return val as OptionType; // already in correct format
    }

    const found = options.find(opt => opt.value === val);
    return found ? found : { value: val, label: String(val) }; // fallback label
  };

  const normalizedValue = normalizeValue(value);
  const normalizedDefault = normalizeValue(defaultValue);

  const getPopupContainer = modal
    ? () =>
        (document.getElementsByClassName('modal')[0] as HTMLElement) ||
        document.body
    : undefined;

  return (
    <Select
      className={className}
      defaultValue={normalizedDefault}
      placeholder={placeholder || 'Select'}
      style={{ width: '100%' }}
      getPopupContainer={getPopupContainer}
      labelInValue
      value={normalizedValue}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.children as unknown as string)
          ?.toLowerCase()
          .includes(input.toLowerCase())
      }
      onChange={(val) => {
        if (onChange && name) {
          onChange({ value: val.value, label: val.label });
        }
      }}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default CustomSelect;
